// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import router from '@/router';
import store from '@/store/store';
import Vuelidate from 'vuelidate';
import VueLazyload from 'vue-lazyload';
import Vue2TouchEvents from 'vue2-touch-events';
import VueYoutube from 'vue-youtube';
import VueAnalytics from 'vue-analytics';
import VueScrollTo from 'vue-scrollto';
import VueMeta from 'vue-meta';
import VueLazy from 'vue-lazy';
import VueMasonry from 'vue-masonry-css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import PortalVue from 'portal-vue';
import Notifications from 'vue-notification';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import Watermark, { setGlobalConfig } from '@serializedowen/vue-img-watermark';
import IdleVue from 'idle-vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faVolumeUp,
  faVolumeMute,
  faCheck,
  faTimes,
  faMapMarkedAlt,
  faMapPin,
  faMapMarker,
  faStreetView,
  faEye,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faSearch,
  faPlay,
  faPause,
  faExpand,
  faCompress,
  faRuler,
  faBed,
  faBath,
  faUserTie,
  faPhone,
  faEnvelope,
  faMusic,
  faExpandAlt,
  faCompressAlt,
  faBook,
  faCalendarDay,
  faFilePdf,
  faLongArrowAltRight,
  faLongArrowAltLeft,
  faDownload,
  faArrowRight
} from '@fortawesome/free-solid-svg-icons';

import './registerServiceWorker';

// Root
import App from './App.vue';

// Components
import Icon from 'vue-awesome/components/Icon';
import TagTemplate from '@/components/tagTemplate/tagTemplate';

// Font awesome list
import 'vue-awesome/icons/street-view';
import 'vue-awesome/icons/play';
import 'vue-awesome/icons/pause';
import 'vue-awesome/icons/expand';
import 'vue-awesome/icons/compress';
import 'vue-awesome/icons/volume-down';
import 'vue-awesome/icons/volume-up';
import 'vue-awesome/icons/volume-mute';
import 'vue-awesome/icons/check-square';

// Directives
import Focus from '@/directives/focus';
import Scroll from '@/directives/scroll';

// Helpers
import { setLazyloaded } from '@/helpers/lazyload';

// Assets
import 'swiper/css/swiper.css';
import 'vue-lazy/dist/vue-lazy.css';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
// import lazyLoaderImg from '@/assets/svg/lazy-loader.svg';

// Font awesome icons
library.add(
  faVolumeUp, 
  faVolumeMute, 
  faCheck, 
  faTimes, 
  faMapMarkedAlt, 
  faStreetView,
  faEye,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faArrowRight,
  faSearch,
  faPlay,
  faPause,
  faExpand,
  faCompress,
  faRuler,
  faBed,
  faBath,
  faUserTie,
  faPhone,
  faEnvelope,
  faMusic,
  faExpandAlt,
  faCompressAlt,
  faBook,
  faCalendarDay,
  faFilePdf,
  faLongArrowAltRight,
  faLongArrowAltLeft,
  faDownload,
  faMapPin,
  faMapMarker
);

// main
Vue.config.productionTip = false;

const isProd = process.env.NODE_ENV === 'production';
const eventsHub = new Vue();

Vue.use(VueAnalytics, {
  id: 'UA-126575569-3',
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
});

Vue.use(VueLazy);
Vue.use(PerfectScrollbar);
Vue.use(VueYoutube);
Vue.use(Vuelidate);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  // loading: lazyLoaderImg,
  attempt: 1,
  lazyComponent: true,
  // throttleWait: 3000,
  adapter: {
    loaded (res) {
      const attributes = res.el.attributes

      if (attributes['data-lazyloaded']) {
        setLazyloaded(store, attributes)
      }
    }
  }
});
Vue.use(Vue2TouchEvents, {
  swipeTolerance: 60
});
Vue.use(VueScrollTo, {
  duration: 1300
});
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});
Vue.use(Watermark);
setGlobalConfig({
  mode: 'bottomright',
  textBaseline: 'middle',
  font: '15px Arial',
  fillStyle: 'white',
  content: 'Copyright Protected',
  rotate: 45
});
Vue.use(Notifications);
Vue.use(VueMasonry);
Vue.use(VueAwesomeSwiper);
Vue.use(PortalVue);
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 2000
})

Vue.component('FontAwesomeIcon', FontAwesomeIcon);
Vue.component('icon', Icon);
Vue.component('tag-template', TagTemplate);

Vue.directive('focus', Focus);
Vue.directive('scroll', Scroll);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});
